import { render, staticRenderFns } from "./ErrorBlock.vue?vue&type=template&id=a33d02d2&"
var script = {}
import style0 from "./ErrorBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports